import { render } from "./RemoteDailyEventItem.vue?vue&type=template&id=65ad3d1c&ts=true"
import script from "./RemoteDailyEventItem.vue?vue&type=script&lang=ts"
export * from "./RemoteDailyEventItem.vue?vue&type=script&lang=ts"

import "./RemoteDailyEventItem.vue?vue&type=style&index=0&id=65ad3d1c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__